

export default function AdminApps({ setApp, isHome }) {
    const handleChandeApp = (app) => {
        setApp(app)
        isHome(false)
    }

    return <section className="flex p-10 gap-10 w-full justify-center">
        <div className="bg-green-600 p-10 rounded-lg transition hover:cursor-pointer hover:bg-green-500 hover:text-black" onClick={ () => handleChandeApp('ImvReg') }> Novo Imovel </div>
        <div className="bg-orange-400 p-10 rounded-lg transition hover:cursor-pointer hover:bg-orange-500 hover:text-white" onClick={ () => handleChandeApp('Imvs') }> Imoveis </div>
        <div className="bg-green-600 p-10 rounded-lg transition hover:cursor-pointer hover:bg-green-500 hover:text-black" onClick={ () => handleChandeApp('Locations') }> Locatarios </div>
    </section>
}